import { Injectable } from '@angular/core';
import rg4js from 'raygun4js';
import { Store } from '@ngrx/store';
import { HttpClient, HttpErrorResponse } from '@angular/common/http';
import { firstValueFrom } from 'rxjs';
import { Ams } from 'src/app/amsconfig';
import { IUserSession } from 'src/app/core/dto';
import { userAuthedSuccessfully } from './store/userSession/actions';

@Injectable({
  providedIn: 'root',
})
export class AuthService {
  constructor(private http: HttpClient, private store: Store) {}

  async checkSession(): Promise<void> {
    try {
      const userSession = await firstValueFrom(
        this.http.get<IUserSession>(`${Ams.Config.BASE_URL}/_api/user/session`)
      );
      this.store.dispatch(userAuthedSuccessfully({ payload: userSession }));
      rg4js('setUser', {
        identifier: `${userSession.userName}@${userSession.serverId}`,
        isAnonymous: userSession.userName === 'guest',
      });
    } catch (error) {
      // On 401 the auth interceptor has already started a window.location.href
      // redirect to /auth/login. Block bootstrap with a never-resolving promise
      // so the splash stays up until the browser unloads — otherwise the
      // dashboard renders for a frame before the navigation lands.
      //
      // EXCEPT in PDF-generation mode: the interceptor deliberately suppresses
      // the login redirect (the headless renderer can't follow it), so hanging
      // here would leave the splash up forever and the captured PDF would just
      // be the splash. Let bootstrap proceed so the report can at least render
      // its shell.
      if (error instanceof HttpErrorResponse && error.status === 401) {
        const isPdfMode =
          new URLSearchParams(window.location.search).get('pdf') === 'true';
        if (!isPdfMode) {
          return new Promise<void>(() => {});
        }
      }
      // Other failures (network, 5xx): let the app bootstrap so any error UI
      // can render rather than leaving the user stuck on the splash.
    }
  }

  logout() {
    window.location.href = `${Ams.Config.BASE_URL}/auth/logout`;
  }
}
